/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const ro = {
  "auth": {
    "user": {
      "new": "Creaza utilizator",
      "edit": "Editeaza utilizator"
    },
    "username": "Nume utilizator (folosit pt autentificare)",
    "email": "E-mail",
    "phoneNumber": 'Numar de telefon',
    "oldPassword": "Parola veche",
    "password": "Parola",
    "passwordConfirmation": "Confirmarea parolei",
    "choosePassword": "Alegeti o parola",
    "passwordRules": "Reguli",
    "atLeastOneLowercase": "Cel putin o litera mica",
    "atLeastOneUppercase": "Cel putin o litera mare",
    "atLeastOneNumeric": "Cel putin o cifra",
    "atLeastOneSpecialCharacter": "Cel putin un caracter special",
    "minimumNineCharacters": "Cel putin 9 caractere",
    "maximum32Characters": "Cel mult 32 caractere",
    "passwordExample": "Exp: parolagauss",
    'changePassword': 'Schimba parola',
    "login": "Autentificare",
    "login-details": "Date autentificare",
    "users": "Utilizatori",
    "rights": "Drepturi",
    "activeRight": "Drept activ",
    "rightName": "Nume Drept",
    "description": "Descriere",
    "companyType": "Tip Companie",
    "edit": "Editare",
    "language": "Limba",
    "cancel": "Anuleaza",
    "save": "Salvare",
    "name": "Nume",
    "add": "Adauga",
    "delete": "Sterge",
    "search": "Cauta",
    "selectAll": "Selecteaza toate rolurile",
    "authenticationLog": "Istoric autentificari",
    "loginDate": "Data autentificare",
    'confirmEmailCheck': 'Accept ca linkul de confirmare utilizator sa fie trimis la e-mailul introdus.',
    "yes": "Da",
    "no": "Nu",
    "error": {
      "bad-credentials": "Utilizator sau parolă incorectă",
      'MaxAttemptsExceededException': 'Ati depasit numarul maxim admis de solicitari!',
      'AttemptsExceededExceptionPT1M': 'Prea multe incercari! Incercati peste 1 minut',
      'AttemptsExceededExceptionPT1H': 'Prea multe incercari! Incercati peste o ora',
      'AttemptsExceededExceptionPT1D': 'Prea multe incercari! Incercati peste o zi',
      'AttemptsExceededExceptionPT10D': 'Prea multe incercari! Incercati peste 10 zile',
      'AttemptsLeft4': 'Mai aveti 4 incercari!',
      'AttemptsLeft3': 'Mai aveti 3 incercari!',
      'AttemptsLeft2': 'Mai aveti 2 incercari!',
      'AttemptsLeft1': 'Mai aveti o incercare!',
      'blocked-user': 'Utilizatorul este blocat temporar din cauza prea multor incercari de autentificare esuate.'
    },
    'warnings': {
      'emailNullReference': 'Pentru a continua navigarea spre alte pagini, trebuie sa setati un email!'
    },
    'errors': {
      'requiredName': 'Campul \'Nume utilizator\' este obligatoriu',
      'name': {
        'minlength': "Numele utilizatorului trebuie sa aiba cel putin 5 caractere",
        'required': "Campul este obligatoriu de completat!"
      },
      'oldPassword': {
        'old-password-match': 'Parola veche nu este corecta!'
      },
      'password': {
        'minlength': 'Parola trebuie sa aiba cel putin 5 caractere',
        'minLength8': 'Parola trebuie sa aiba cel putin 8 caractere',
        'required': "Campul este obligatoriu de completat!",
        'customPattern': "Parola trebuie sa contina cel putin o litera mica, cel putin o litera mare, cel putin o cifra, cel putin un caracter special, trebuie sa aiba minim 9 caractere si maxim 32 de caractere!",
        'requiredPassword': 'Parola este obligatorie!'
      },
      'passwordConfirmation': {
        'minlength': 'Parola trebuie sa aiba cel putin 5 caractere',
        'required': "Campul este obligatoriu de completat!",
        'passwordConfirmationMatchError': 'Confirmarea parolei nu coincide cu parola',
        'requiredPassword': 'Confirmarea parolei este obligatorie!',
        'customPattern': 'Parola trebuie sa contina cel putin o litera mica, cel putin o litera mare, cel putin o cifra, cel putin un caracter special, trebuie sa aiba minim 9 caractere si maxim 32 de caractere!'
      },
      'emailEmail': 'Adresa de email este invalida',
      'email': {
        'pattern': 'Adresa de email este invalida',
        'required': 'Campul este oblicatoriu de completat!'
      },
      'requiredConfirmEmail': 'Bifati ca ati luat la cunostinta trimiterea emailului de confirmare la adresa introdusa.',
      'customPatternEmail': 'Adresa de email este invalida'
    },
    "activeTo": "Activ pana la",
    "indefinitely": "Termen nedeterminat",
    "itemsSelected": "{0} selectate",
    "activeOpts": {
      "active": "Activi",
      "inactive": "Inactivi",
      "all": "Toti"
    },
    "role": {
      "isPlatform": "Rol Platforma",
      "newRole": "Denumire rol nou",
      "descriptionPlaceholder": "Introduceti descrierea rolului",
      'confirmDeletion': 'Sunteti sigur ca doriti sa stergeti rolul?',
      'editRole': 'Editeaza rol',
      'cloneRole': 'Creeaza un rol duplicat',
      'assigned': 'Rol atribuit',
      'otherRights': 'Alte Drepturi'
    },
    'validatePhoneNumber': 'Validare numar de telefon',
    'validationCode': 'Cod de validare',
    'sendSmsValidation': 'Trimite SMS pentru validare',
    'validateCode': 'Valideaza cod',
    'invalidCode': 'Cod de validare gresit!',
    'invalidPhoneNumber': 'Numar de telefon invalid',
    "otpCodeSuccess": "Un mesaj cu codul de validare a fost trimis pe numarul tau!",
    "phoneNumberRequiredMessage": "Este necesar sa aveti un numar valid de telefon introdus!",
    "phoneNumberValidateSuccessMessage": "Numarul de telefon a fost validat!",
  }
}
